const numberify = (value) => {
  if (value) {
    const formattedValue = value.replace(/\:/g, ".");
    const asDecimal = Number(formattedValue.slice(0, 2)) + Number((formattedValue.slice(2) / 60) * 100);
    return Number(asDecimal);
  }
};

export const numberifyMinutes = (value) => {
  if (+value <= 0) {
    return 0;
  } else if (value) {
    const formattedValue = "00." + value;
    const asDecimal = Number(formattedValue.slice(0, 2)) + Number((formattedValue.slice(2) / 60) * 100);
    return Number(asDecimal);
  }
};
export default numberify;
